import * as TYPES from '../types';

export const addResearchAction = (payload) => {
    return {
        type: TYPES.ADD_RESEARCH,
        payload: payload
    };
};

export const getAllResearchAction = () => {
    return {
        type: TYPES.GET_ALL_RESEARCH,
    };
};

export const getAllResearchSuccessAction = (payload) => {
    return {
        type: TYPES.GET_ALL_RESEARCH_SUCCESS,
        payload: payload
    };
};

export const deleteResearchAction = (payload) => {
    return {
        type: TYPES.DELETE_RESEARCH,
        payload: payload
    };
};

export const editResearchAction = (payload) => {
    return {
        type: TYPES.EDIT_RESEARCH,
        payload: payload
    };
};

export const deleteResearchGalleryImageAction = (payload) => {
    return {
        type: TYPES.DELETE_RESEARCH_GALLERY_IMAGE,
        payload: payload
    };
};

export const updateResearchStatusAction = (payload) => {
    return {
        type: TYPES.UPDATE_RESEARCH_STATUS_IMAGE,
        payload: payload
    };
};
